import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button as AntButton } from 'antd';
import StartClassDatePicker from '../../../../StartClassDatePicker';
import useNotification from '../../../../../hooks/useNotification';
import useAxios from '../../../../../hooks/useAxios';
import { IGetNotifications } from '../../../../../models/notification.model';
import Loader from '../../../../Loader';
import ErrorResponse from '../../../../ErrorResponse';
import { getNotifications } from '../../../../../api/notification.api';

interface IProps {
  visible: boolean;
  classCode: string;

  onOk(startDate: string, timetableCode: number): void;

  onCancel(): void;
}

const SubmitModal: FC<IProps> = ({ visible, classCode, onOk, onCancel }) => {
  const {
    data: res,
    isLoading,
    error,
    execute,
  } = useAxios<IGetNotifications>();
  const { t } = useTranslation();
  const { infoNotification } = useNotification();

  const [startDate, setStartDate] = useState('');

  const onSubmit = () => {
    if (!startDate) return infoNotification(t('student.student.message14'));
    const timetableCode = res?.data?.find(item => item.timetableDate === startDate)?.timetableCode;
    if (timetableCode) onOk(startDate, timetableCode);
  };

  useEffect(() => {
    execute(getNotifications(classCode));
  }, [classCode]);

  return (
    <Modal title={t('student.student.title5')} visible={visible}
      footer={[
        <div className='comm-btn__area justify-content-center'>	
          <AntButton
            key="submit"
            className='btn-basic pink'
            onClick={onSubmit}
          >
            {t('common.button.confirm')}
          </AntButton>
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={onCancel}
          >
            {t('common.button.cancel')}
          </AntButton>
        </div>
      ]}
    >
      {isLoading && <Loader />}
      <ErrorResponse error={error} />
      <div className="text-center">
        {t('student.student.column71')}:{' '}
        <StartClassDatePicker
          startDate={startDate}
          notificationItemList={res?.data ?? []}
          onStartDateChange={setStartDate}
        />
      </div>
    </Modal>
  );
};

export default SubmitModal;
